module.exports = __webpack_public_path__ + "img/PermanentAccess.ead9bfc.svg";